import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "roswitch",
    on: {
      "click": _vm.onClick
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.on,
      expression: "on"
    }],
    attrs: {
      "type": "checkbox",
      "name": "autorenew"
    },
    domProps: {
      "checked": Array.isArray(_vm.on) ? _vm._i(_vm.on, null) > -1 : _vm.on
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.on,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.on = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.on = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.on = $$c;
        }
      }
    }
  }), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "roswitch-simple-wrapper"
  }, [_c('div', {
    staticClass: "roswitch-toggle-btn"
  })]);
}];
export { render, staticRenderFns };